// Takes an iterable of key/value pairs and converts it into an array.

export const fromEntries = (entries) =>
    Array.from(entries).reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
    }, {});
